import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

import api from "../../../../api";


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            Nombre: "",
            ValoresDePropiedad:[],
            postVariables: ['Nombre', 'ValoresDePropiedad'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    validate(){
      const errors = {};
      const pushError = (fieldName, code, detail, errors) => errors[fieldName] = [{code, detail}];
      if(this.state.Nombre != null && this.state.Nombre.trim().length == 0) pushError('Nombre', 'invalid', 'Nombre no puede ser vacio.', errors);
      this.setErrors(errors);
      return Object.keys(errors).length == 0;
    }

    resetForm() {
        this.setState({
            id: null,
            Nombre: "",
            ValoresDePropiedad:[],
            Padre_id: null,
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                Nombre: data.Nombre,
                ValoresDePropiedad: data.ValoresDePropiedad ? data.ValoresDePropiedad : [],
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    updateValoresDePropiedad(newVal){
      try {
        const generarNuevoValor = () => ({Nombre:''});
        newVal = parseInt(newVal);
        if(newVal > 15) newVal = 15;
        if(newVal > 0 && this.state.ValoresDePropiedad.length != newVal){
          this.setState(prevState => {
            let newValues = [];
            let agregar = prevState.ValoresDePropiedad.length < newVal;
            let quitar = prevState.ValoresDePropiedad.length > newVal;
            for (let i = 0; i < newVal; i++) {
              if(agregar) newValues.push(i < prevState.ValoresDePropiedad.length ? prevState.ValoresDePropiedad[i] : generarNuevoValor());
              else if(quitar) newValues.push(prevState.ValoresDePropiedad[i]);
            }
            prevState.ValoresDePropiedad = newValues;
            return prevState;
          });
        }
      } catch (e) { }
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Caracteristica",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Caracteristica ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Caracteristica",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Caracteristica ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Caracteristica",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Caracteristica",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Caracteristica ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        let vars = this.modalVars();
        const { action } = this.props;
        return (
            <ParadigmaModal
              getUrl={(vars.get ? api.gestion.articulos.propiedades : null)}
              submitUrl={(vars.submitType ? api.gestion.articulos.propiedades : null)}
              submitType={vars.submitType}
              id={vars.id}

              onGotData={(data) => this.setData(data)}
              onGotErrors={(errors) => this.setErrors(errors)}
              onSubmit={(e) => this.props.onSubmit(e) & this.resetForm()}
              onClose={() => this.resetForm()}
              onPreSubmit={() => this.getData()}
              onValidation={() => this.validate()}

              title={vars.title}

              danger={vars.danger}
              buttonClass={vars.buttonClass}

              successMessage={vars.successMessage}
              missingIdMessage={"Debe seleccionar una fila."}
              saveButtonLabel={vars.saveButtonLabel}
              buttonTitle={vars.buttonTitle}
              buttonIcon={vars.buttonIcon}
              saveButton={vars.saveButton}
              saveReloadButton={action == "CREATE"}
              saveReloadButtonLabel="Guardar y Nueva"
              closeButton={true}
            >
              <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                label={"Nombre"}
                value={this.state.Nombre}
                onChange={(e) => this.onChangeField('Nombre', e.target.value)}
                error={() => this.getError('Nombre')}
              />
              <hr/>
              <Row className="mb-1">
                <Col xs={2}><Label>Valores</Label></Col>
                <Col xs={2}>
                  <Input
                    type="number"
                    min={0}
                    disabled={vars.disabled}
                    max={15}
                    value={this.state.ValoresDePropiedad.length}
                    onChange={(e) => this.updateValoresDePropiedad(e.target.value)}
                  />
                </Col>
              </Row>
              {
                this.state.ValoresDePropiedad.map((val,index)=>(
                  <Row className="mb-1">
                    <Col>
                      <Input
                        key={`valor-${index}`}
                        disabled={vars.disabled}
                        placeholder="Nuevo Valor"
                        value={val.Nombre}
                        onChange={(evt) => {
                          const idx = index;
                          const value = evt.target.value;
                          this.setState(prevState=>{
                            try {
                              let ValoresDePropiedad = [...prevState.ValoresDePropiedad];
                              ValoresDePropiedad[idx].Nombre = value;
                              prevState.ValoresDePropiedad = ValoresDePropiedad;
                            } catch (e) { }
                            return prevState;
                          })
                        }}
                      />
                    </Col>
                  </Row>
                ))
              }
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Propiedades/Modal.js